import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found | ABSLpay" description="The page you requested could not be found." path="/404" noindex />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-28 text-center">
        <p className="font-mono-num text-sm font-bold text-emerald-600">404</p>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
          That page moved or never existed.
        </h1>
        <p className="mt-4 text-base text-slate-600">Check the address, or start from one of these pages.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link to="/" data-testid="notfound-home-btn" className="rounded-full bg-slate-900 text-white font-bold px-7 py-3.5 hover:bg-emerald-700 transition-colors">
            Go to the home page
          </Link>
          <Link to="/payroll-services" data-testid="notfound-states-btn" className="rounded-full border border-slate-300 bg-white font-bold px-7 py-3.5 text-slate-800 hover:border-slate-900 transition-colors">
            Find your state
          </Link>
        </div>
      </section>
    </>
  );
}
